import React from 'react';
import { Redirect, Prompt } from 'react-router-dom';
import ModalEnabled from '../extend/ModalEnabled';
import { clientAPI } from '../../InterfaceAPI/clientAPI';
import DetailsBar from '../shared/DetailsBar';
import BackButton from '../shared/BackButton';
import HeadingPlaceholder from '../shared/HeadingPlaceholder';
import TextAreaModal from '../shared/TextAreaModal';
import TextAreaView from '../shared/TextAreaView';
import ClientServices from '../client/ClientServices';
import ClientEditDetailsModal from '../client/ClientEditDetailsModal';
import ClientAccountToggleModal from '../client/ClientAccountToggleModal';
import AccountStatus from '../shared/AccountStatus';
import ClientEditWeeklySettingsModal from '../client/ClientEditWeeklySettingsModal';
import InfinityCardSection from '../shared/InfinityCardSection';
import AddressCardNew from '../shared/AddressCardNew';
import AddressCard from '../shared/AddressCard';
import AddressModal from '../shared/AddressModal';
import AddressDeleteModal from '../shared/AddressDeleteModal';
import ContactInformationBar from '../shared/ContactInformationBar';
import ConfirmModal from '../shared/ConfirmModal';
import withSplashMessage from '../splashMessage/withSplashMessage';
import SVGTrash from '../../svg/Trash';
import PaymentModal from '../shared/PaymentModal';
import { adminMenuSelectionSwitch } from '../../helpers/switches';
import { mapSelectOptions, stringfyServerErrors } from '../../helpers/util';
import {
  maskCapitalizeFirstLetter,
  maskDate,
  maskMoney,
  maskPrependComma,
  maskServiceEndTime,
  maskServiceStartTime,
  adminClientName
} from '../../masks';
import { authAPI } from '../../InterfaceAPI/authAPI';
import ENV_CONFIG from '../../env';
import withTracker from '../withTracker';
import Loader from '../shared/Loader';
import { ACCOUNT_STATUSES } from '../../const.js';

class AdminClient extends ModalEnabled {
  defaultClientState = {
    service_addresses: [],
    base_fee_cents: 25000,
    client_101: "<p><strong>SPECIAL INSTRUCTIONS:</strong></p>\n<p><br></p>\n<p><strong>HOUSEHOLD NOTES:</strong></p>",
    private_notes: 
      `<p><strong>PERSONAL:</strong></p>\n
        <ul>\n
          <li><strong>Job:</strong></li>\n
          <li><strong>Household:</strong></li>\n
          <li><strong>Assistant:</strong></li>\n
          <li><strong>Other Emails:</strong></li>\n
          <li><strong>Other Numbers:</strong></li>\n
          <li><strong>Referral Source:</strong></li>\n
          <li><strong>Locations:</strong></li>\n
        </ul>\n
        <p><strong>CULINARY NOTES:</strong></p>\n
        <ul>\n
          <li><br></li>\n
        </ul>\n
        <p><strong>CHEF NOTES:</strong></p>\n
        <ul>\n
          <li><br></li>\n
        </ul>\n
        <p><strong>OCCASION MENUS:</strong></p>\n
        <ul>\n
          <li><br></li>\n
        </ul>\n
        <p><strong>OTHER:</strong></p>`
  };

  state = {
    client: { ...this.defaultClientState },
    addressIndex: -1,
    unsaved: false,
    redirect_to: '',
    isLoading: true
  };

  detailsBarProperties = [
    {
      label: 'Service Count',
      combine: [
        { key: 'services_stats', dive: 'total_weekly', mask: (val) => `${val}`  },
        { raw: ' Weekly' },
        { raw: ' ', className: '--new-line' },
        { key: 'occasion_count', mask: (val) => `${val}`  },
        { raw: ' Occasion' }
      ]
    },
    {
      label: 'Portion Size',
      key: 'portion_size',
      mask: maskCapitalizeFirstLetter
    },
    { label: 'Diet', key: 'dietary_preference_tags', dive: 'tag' },
    {
      label: 'Allergens',
      combine: [
        { key: 'allergen_tags', dive: 'tag' },
        { key: 'other_allergens', mask: maskPrependComma }
      ]
    },
    { label: 'Base Fee', key: 'base_fee_cents', mask: maskMoney }
  ];

  dishSelectionOptions = [
    'client_picks',
    'culinistas_picks',
    'custom_weekly_selection'
  ];

  clientServiceListColumns = [
    { label: 'Date', key: 'date', sortable: false, mask: maskDate },
    {
      label: 'Time',
      sortable: false,
      combine: [
        { key: 'start_time', mask: maskServiceStartTime },
        { key: 'end_time', mask: maskServiceEndTime }
      ]
    },
    {
      label: 'Chef',
      key: 'invited_chefs',
      dive: ['chef', 'name'],
      sortable: false
    },
    {
      label: 'Service Type',
      key: 'service_type',
      sortable: false,
      mask: maskCapitalizeFirstLetter
    },
    {
      link: { to: '/admin/service/[id]', label: 'View', target: '_blank' },
      sortable: false
    }
  ];

  render() {
    const { refresh, client, redirect_to, unsaved, isLoading } = this.state;
    const clientName = adminClientName(client)
    //TODO should we handle verification pending differently?
    const isActive = client.account_status !== ACCOUNT_STATUSES.DEACTIVATED;
    if (redirect_to) return <Redirect to={redirect_to} />;
    if (refresh) {
      this.setState({ refresh: false})
      window.location.reload(false)
    }

    if (isLoading) return <Loader />;

    return (
      <div className="cms">
        <div className="cms__head cms__head--padding">
          <div className="cms__content">
            <BackButton defaultUrl="/admin/clients" />
            {client.id && (
              <AccountStatus
                accountType="Client"
                accountStatus={client.account_status}
                date={isActive ? client.created_at : client.deactivated_at}
              />
            )}
            <div className="cms__bar">
              <HeadingPlaceholder
                value={clientName === ' ' ? null : clientName}
                placeholder="Client"
                label="Client"
              />
              <div className="cms__bar-ctas">
                <div
                  className="btn-icon btn-icon--trash"
                  onClick={() => this.openModal('delete')}
                >
                  <SVGTrash />
                </div>
                <div
                  className="cms__bar-cta btn btn--link btn--full-mobile"
                  onClick={() => this.openModal('reset-password')}
                >
                  Reset Password
                </div>
                <div
                  className="btn btn--hollow-blue"
                  onClick={() => this.openModal('edit-details')}
                >
                  Edit Details
                </div>
                <input
                  type="submit"
                  className="btn btn--solid-blue"
                  onClick={this.handleSubmit}
                  value="Save"
                />
                {!isActive &&
                  <div
                    className="btn btn--solid-blue"
                    onClick={this.toggleAccountStatus}
                  >
                    Activate Account
                  </div>
                }
              </div>
            </div>
            <ContactInformationBar
              phone={client.phone_number}
              email={client.email}
              unconfirmed_email={client.unconfirmed_email}
            />
            <DetailsBar data={client} columns={this.detailsBarProperties} />
          </div>

          {this.renderSpecialInstructions()}
        </div>

        <div className="cms__body">
          <div className="cms__content">
            <div className="row">
              <div className="row__item row__item--half row__item--pad-right">
                <TextAreaView
                  value={client.client_101}
                  openEdit={() => this.openModal('client-101')}
                  title="Client 101"
                />
              </div>
              <div className="row__item row__item--half row__item--pad-left">
                <TextAreaView
                  value={client.private_notes}
                  openEdit={() => this.openModal('private-notes')}
                  title="Private Notes"
                />
              </div>
            </div>

            <div className="row">
              <InfinityCardSection
                sectionHeading="Service Address"
                iterable={client.service_addresses}
                Card={AddressCard}
                cardProps={{
                  totalCards: client.service_addresses.length,
                  editAddress: i => this.openAddressModal('edit-address', i),
                  deleteAddress: i =>
                    this.openAddressModal('delete-address', i),
                  markDefaultAddress: this.markDefaultAddress,
                  canEdit: true
                }}
                onAddNew={() => this.openAddressModal('edit-address', -1)}
                NewCard={AddressCardNew}
              />
            </div>

            <div className="row">
              <div className="cms__section">
                <div className="cms__bar cms__section-head">
                  <div className="cms__bar-left">
                    <h3 className="h3">Payment</h3>
                  </div>
                </div>
                <div
                  className="btn btn--hollow-blue"
                  onClick={() => this.openModal('edit-payment')}
                >
                  Edit Payment
                </div>
              </div>
            </div>

            <div className="row">
              <ClientServices
                client={client}
                updateClient={this.updateClient}
                menuSelectionSwitch={adminMenuSelectionSwitch}
                openSettingsModal={() => this.openModal('weekly-settings')}
                columns={this.clientServiceListColumns}
              />
            </div>
            {client.id > 0 && isActive ? (
              <div className="row">
                <div
                  className="btn btn--hollow-red"
                  onClick={() => this.openModal('toggle-status')}
                >
                  Deactivate
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>

        <TextAreaModal
          title="Client 101"
          value={client.client_101}
          isOpen={this.isOpen('client-101')}
          closeModal={this.closeModal}
          onSubmit={client_101 => this.updateClient({ client_101 })}
        />

        <TextAreaModal
          title="Private Notes"
          value={client.private_notes}
          isOpen={this.isOpen('private-notes')}
          closeModal={this.closeModal}
          onSubmit={private_notes => this.updateClient({ private_notes })}
        />

        <ClientEditDetailsModal
          isOpen={this.isOpen('edit-details')}
          closeModal={this.closeModal}
          client={client}
          updateClient={this.updateClient}
          allowEditEmail={true}
          showBaseRate={true}
        />

        <AddressModal
          isOpen={this.isOpen('edit-address')}
          closeModal={this.closeModal}
          address={this.getAddress(this.state.addressIndex)}
          addressIndex={this.state.addressIndex}
          updateAddress={this.updateAddress}
        />

        <AddressDeleteModal
          isOpen={this.isOpen('delete-address')}
          closeModal={this.closeModal}
          address={this.getAddress(this.state.addressIndex)}
          addressIndex={this.state.addressIndex}
          deleteAddress={this.deleteAddress}
        />

        <PaymentModal
          isOpen={this.isOpen('edit-payment')}
          closeModal={this.closeModal}
          client={client}
        />

        <ClientEditWeeklySettingsModal
          isOpen={this.isOpen('weekly-settings')}
          closeModal={this.closeModal}
          dishSelectOptions={mapSelectOptions(
            this.dishSelectionOptions,
            adminMenuSelectionSwitch
          )}
          client={client}
          updateClient={this.updateClient}
        />

        <ClientAccountToggleModal
          isOpen={this.isOpen('toggle-status')}
          closeModal={this.closeModal}
          client={client}
          toggleAccountStatus={this.toggleAccountStatus}
        />

        <ConfirmModal
          isOpen={this.isOpen('delete')}
          closeModal={this.closeModal}
          onSubmit={this.hardDeleteClient}
          heading="Delete This Client?"
          body={`The client "${clientName}" will permanently deleted.`}
          cta="Delete Client"
        />

        <ConfirmModal
          isOpen={this.isOpen('reset-password')}
          closeModal={this.closeModal}
          onSubmit={this.handleResetPassword}
          heading="Reset Password"
          body="This will send an email to reset the password. Are you sure?"
          cta="Okay"
        />

        <Prompt when={unsaved} message="You have unsaved data, are you sure?" />
      </div>
    );
  }

  renderSpecialInstructions() {
    return (
      <div className="cms__content cms__content--pad-top">
        <div className="row">
          <div className="cms__section">
            <div className="cms__bar cms__section-head">
              <div className="cms__bar-left">
                <h3 className="h3">Special Instructions</h3>
              </div>
            </div>
            <div className="cms__section-body special-instructions">
              <p className="p">{this.state.client.special_instructions}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  updateClient = updatedClient => {
    const client = {
      ...this.state.client,
      ...updatedClient
    };

    if (
      updatedClient.menu_selection_status &&
      updatedClient.menu_selection_status === 'custom_weekly_selection'
    ) {
      client.custom_weekly = true;
      client.weekly = false;
    } else if (updatedClient.menu_selection_status) {
      client.custom_weekly = false;
      client.weekly = true;
    }

    this.setState({ client, openModal: '', addressIndex: -1 }, () =>
      console.log(this.state, 'UPDATE CLIENT')
    );
  };

  updateAddress = (index, updatedAddress) => {
    const service_addresses = [...(this.state.client.service_addresses || [])];
    if (index >= 0) service_addresses[index] = updatedAddress;
    else service_addresses.push(updatedAddress);

    this.updateClient({ service_addresses });
  };

  deleteAddress = index => {
    const { client } = this.state;
    const service_addresses = [
      ...client.service_addresses.slice(0, index),
      ...client.service_addresses.slice(
        index + 1,
        client.service_addresses.length
      )
    ];
    this.updateClient({ service_addresses });
  };

  markDefaultAddress = index => {
    const service_addresses = this.state.client.service_addresses.map(
      (address, idx) => {
        address.default = idx === index;
        return address;
      }
    );
    this.updateClient({ service_addresses });
  };

  openAddressModal = (type, addressIndex = -1) =>
    this.openModal(type, { addressIndex });

  getAddress = index => {
    const { service_addresses = [] } = this.state.client;
    return index >= 0 && service_addresses.length > 0
      ? service_addresses[index]
      : {};
  };

  hardDeleteClient = () => {
    const { client } = this.state;
    clientAPI
      .deleteClient(client.id, true)
      .then(success => {
        this.props.addMessage({
          className: 'success',
          message: `"${client.name}" has been deleted.`
        });
        this.setState({ redirect_to: '/admin/clients', unsaved: false });
      })
      .catch(error => {
        console.log(error);
        this.props.addMessage({
          className: 'error',
          message: `Error deleting client: ${stringfyServerErrors(error)}`
        });
      });
  };

  handleResetPassword = () => {
    const { client } = this.state;

    const LocalRedirectUrl = `${ENV_CONFIG.REACT_APP_SCHEMA}://${
      document.domain
    }/reset-password/client`;

    const payload = {
      role: 'client',
      email: client.email,
      redirect_url: LocalRedirectUrl //`${ENV_CONFIG.REACT_APP_SCHEMA}://${ENV_CONFIG.REACT_APP_APP_HOST}/reset-password/client`,
    };
    authAPI
      .forgotPassword(payload)
      .then(res => {
        this.props.addMessage({
          className: 'error',
          message:
            "We've just sent you an email with instructions on how to resend your password"
        });
        this.closeModal();
      })
      .catch(err => {
        this.props.addMessage({
          className: 'error',
          message: stringfyServerErrors(err)
        });
        this.closeModal();
      });
  };

  toggleAccountStatus = () => {
    const client = { ...this.state.client };
    const isActive = client.account_status !== ACCOUNT_STATUSES.DEACTIVATED;

    if (isActive) {
      // delete
      clientAPI
        .deleteClient(client.id)
        .then(success => {
          this.props.addMessage({
            className: 'success',
            message: `"${client.name}" has been deactivated.`
          });
          this.setState({
            client,
            redirect_to: '/admin/clients',
            unsaved: false
          });
        })
        .catch(error => {
          console.log(error);
          this.props.addMessage({
            className: 'error',
            message: `Error deactivating client: ${error}`
          });
        });
    } else {
      // restore
      clientAPI
        .restoreClient(client.id)
        .then(success => {
          this.props.addMessage({
            className: 'success',
            message: `"${client.name}" has been reactivated.`
          });
          this.setState({
            client,
            redirect_to: '/admin/clients',
            unsaved: false
          });
        })
        .catch(error => {
          console.log(error);
          this.props.addMessage({
            className: 'error',
            message: `Error restoring client: ${error}`
          });
        });
    }
  };

  handleSubmit = () => {
    const client = { ...this.state.client };
    if (client.id)
      clientAPI
        .updateClient(client)
        .then(client => {
          this.props.addMessage({
            className: 'success',
            message: `"${client.name}" has been updated.`
          });
          this.setState({
            client,
            refresh: true,
            unsaved: false
          });
        })
        .catch(error => {
          console.log(error);
          this.props.addMessage({
            className: 'error',
            message: `Error saving client: ${error}`
          });
        });
    else
      clientAPI
        .createClient(client)
        .then(client => {
          console.log(client);
          this.props.addMessage({
            className: 'success',
            message: `"${client.name}" has been created.`
          });
          this.setState({
            client,
            redirect_to: '/admin/clients',
            unsaved: false
          });
        })
        .catch(error => {
          console.log(error);
          this.props.addMessage({
            className: 'error',
            message: `Error saving client: ${error}`
          });
        });
  };

  loadClient(id) {
    clientAPI
      .getClient(id)
      .then(client => this.setState({ client, isLoading: false }))
      .catch(this.handleErrorLoading);
  }

  handleErrorLoading = error => {
    console.log(error);
    const pathname = '/admin/clients';
    const redirect_to = { pathname };

    const { state } = this.props.location;
    if (state) {
      const { redirect_url, redirect_payload } = state;
      if (redirect_url) {
        redirect_to.pathname = redirect_url;
      }

      if (redirect_payload) redirect_to.state = { ...redirect_payload };
    }
    this.props.addMessage({
      className: 'error',
      message: stringfyServerErrors(error)
    }); // todo: add messaging
    this.setState({ redirect_to, isLoading: false });
  };

  generateNewClient() {
    this.setState({ client: { ...this.defaultClientState }, isLoading: false });
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    if (id === 'create') this.generateNewClient();
    else if (id > 0) {
      this.loadClient(id);
    }
  }
}
export default withSplashMessage(withTracker(AdminClient));



// WEBPACK FOOTER //
// ./src/components/admin/AdminClient.js